import { VALID_CLEAN_UUID_REGEXP } from './constants';

/**
 * Tests if the passed argument is a valid "clean" UUID string.
 * @param val The id to test.
 */
export const isCleanUuid = (val: unknown): val is string =>
  typeof val === 'string' && VALID_CLEAN_UUID_REGEXP.test(val);
